<!-- Форма создания и редактирования автопарка. -->
<template>
  <form
    :id="id"
    class="modal-form fleet-park-form"
    @submit.prevent="submit"
  >
    <BaseFormField
      label="Название"
      for-id="fleet_park_name"
      required
      :filled="!!formData.name"
      :error="errors.name"
    >
      <base-input
        id="fleet_park_name"
        v-model="formData.name"
        :invalid="errors.name"
        @update:modelValue="errors.name = false"
      />
    </BaseFormField>

    <BaseFormField
      label="Дневная норма пробега"
      for-id="fleet_park_daily_target_km"
      required
      :filled="!!formData.daily_target_km"
      :error="errors.daily_target_km"
      error-message="Укажите дневную норму пробега"
    >
      <base-input
        id="fleet_park_daily_target_km"
        v-model="formData.daily_target_km"
        type="number"
        placeholder="700"
      />
    </BaseFormField>
  </form>
</template>

<script>
export default {
  name: "FleetParkForm",

  props: {
    id: {
      type: String,
      required: true,
    },
    fleetPark: {
      type: Object,
      default: null,
    },
  },

  emits: ["submit"],

  data() {
    return {
      formData: this.initialFormData(),
      errors: {
        name: false,
        daily_target_km: false,
      },
    };
  },

  watch: {
    fleetPark() {
      this.resetForm();
    },
  },

  methods: {
    initialFormData() {
      return {
        name: this.fleetPark?.name || "",
        daily_target_km: this.fleetPark?.daily_target_km || 700,
      };
    },

    resetForm() {
      this.formData = this.initialFormData();
      this.errors = {
        name: false,
        daily_target_km: false,
      };
    },

    validateForm() {
      this.errors.name = !String(this.formData.name || "").trim();
      this.errors.daily_target_km = !this.dailyTargetKmValid();

      return !Object.values(this.errors).some(Boolean);
    },

    dailyTargetKmValid() {
      return Number(this.formData.daily_target_km) > 0;
    },

    submit() {
      if (!this.validateForm()) return;

      this.$emit("submit", { ...this.formData });
    },
  },
};
</script>

<style scoped>
.fleet-park-form {
  display: flex;
  flex-direction: column;
  gap: 14px;
}
</style>
